import { render, staticRenderFns } from "./TransferGraduationSendDocument.vue?vue&type=template&id=1308477f&scoped=true&"
import script from "./TransferGraduationSendDocument.vue?vue&type=script&lang=ts&"
export * from "./TransferGraduationSendDocument.vue?vue&type=script&lang=ts&"
import style0 from "./TransferGraduationSendDocument.vue?vue&type=style&index=0&id=1308477f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1308477f",
  null
  
)

export default component.exports